<template>
  <v-col :cols="12" :sm="12" :md="12">
    <v-alert type="error" v-show="erro">{{ mensagemErro }}</v-alert>

    <v-alert
      v-show="newNotify.isNewNotify"
      border="left"
      close-text="Close Alert"
      color="green accent-4"
      dark
      @click="newNotify.isNewNotify = false"
    >
      {{ newNotify.text }}
    </v-alert>

    <DataTable
      v-show="showSkeletonTable == false"
      :tableTitle="'Produtos no Sistema'"
      :newRowmodalButtonText="'Novo Produto'"
      :tableHeader="headers"
      :tableRows="itens"
      :isView="false"
      :isFinish="false"
      :isEdit="true"
      :isDel="true"
      :isPrint="false"
      v-on:datatable-newrow="abrirModalInserir"
      v-on:datatable-updaterow="abrirModalEditar"
      v-on:datatable-deleterow="deletarItem"
    ></DataTable>

    <SkeletonTable
      v-show="showSkeletonTable == true"
      :showSkeletonTable="showSkeletonTable"
    ></SkeletonTable>

    <Loading :open="loading" />

    <ModalCustomSize
      :modalSize="modalCustomSize.size"
      :isTheModalOpen="modalCustomSize.isOpen"
      :modalButtonText="modalCustomSize.buttonText"
      :modalFormTitle="modalCustomSize.formTitle"
      :modalType="modalCustomSize.modalType"
      :isLoadingRequestDisable="modalCustomSize.isLoadingRequestDisable"
      :isModalButtonVisible="modalCustomSize.isButtonsVisible"
      :isModalButtonDisabled="modalCustomSize.isButtonsDisabled"
      v-on:formmodal-close="modalCustomSize.isOpen = false"
      v-on:formmodal-action="onFormModalAction"
    >
      <v-alert
        transition="scale-transition"
        type="error"
        text
        v-show="mensagemErroModal.erro"
        >{{ mensagemErroModal.text }}</v-alert
      >

      <v-form v-model="isFormValid">
        <v-row>
          <v-col cols="6">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-bind="attrs"
                  v-on="on"
                  v-model="modalCustomSize.actualEdit.nomeItem"
                  name="nomeItem"
                  label="Nome do Produto"
                  :rules="[rules.required, rules.limitCharacters]"
                  counter="255"
                ></v-text-field>
              </template>
              <span>{{ modalCustomSize.actualEdit.nomeItem }}</span>
            </v-tooltip>
          </v-col>

          <v-col cols="6">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-bind="attrs"
                  v-on="on"
                  v-model="modalCustomSize.actualEdit.descricaoItem"
                  name="descricaoItem"
                  label="Descrição do Produto"
                ></v-text-field>
              </template>
              <span>{{ modalCustomSize.actualEdit.descricaoItem }}</span>
            </v-tooltip>
          </v-col>
          <v-col cols="12">
            <v-autocomplete
            v-model="modalCustomSize.actualEdit.tipoProduto"
            :items="tipoProduto"
            label="Tipo de Insumo"
          ></v-autocomplete>
          </v-col>
        </v-row>
      </v-form>
    </ModalCustomSize>
  </v-col>
</template>

<script>
import store from "@/store/index";
import axios from "../plugins/axios";
import DataTable from "@/components/DataTable2.vue";
import SkeletonTable from "../components/SkeletonTable";
import Loading from "../components/Loading.vue";
import ModalCustomSize from "@/components/ModalCustomSize.vue";

export default {
  components: {
    DataTable,
    SkeletonTable,
    Loading,
    ModalCustomSize,
  },

  data: () => ({
    newNotify: {
      isNewNotify: false,
      text: "",
    },

    mensagemErroModal: {
      erro: false,
      text: null,
    },

    erro: false,
    mensagemErro: "Erro",

    config: {
      headers: {
        "Content-Type": "application/json",
        "x-auth-token": store.state.token,
      },
    },

    isFormValid: false,
    showSkeletonTable: true,
    loading: false,

    headers: [
      {
        text: "ID",
        value: "numeroItemSistema",
      },
      {
        text: "Nome do Produto",
        value: "nomeItemSistema",
      },
      {
        text: "Descrição do Produto",
        value: "descricaoItemSistema",
      },
      { text: "Ações", value: "actions", sortable: false },
    ],

    modalCustomSize: {
      size: "1400",
      isOpen: false,
      buttonText: "",
      formTitle: "",
      isEdit: false,
      isLoadingRequestDisable: false,
      isButtonsVisible: true,
      isButtonsDisabled: false,
      actualEdit: {
        numeroItemSistema: null,
        nomeItem: null,
        descricaoItem: null,
        tipoProduto: null
      },
    },

    itens: [],

    tipoProduto:[ 
      {
        text: "Liberado para dispensa",
        value: 0,
      },
      {
        text: "Restrito para dispensa",
        value: 1,
      },
      {
        text: "Teste Rápido HIV",
        value: 2,
      },
      {
        text: "Teste Rápido SIFILIS",
        value: 3,
      },
      {
        text: "Teste Rápido HEP B",
        value: 4,
      },
      {
        text: "Teste Rápido HEP C",
        value: 5,
      },
      {
        text: "Teste Rápido DUO - HVI/SIFILIS",
        value: 6,
      },
    ],

    rules: {
      required: (value) => !!value || "Requer o campo!",
      limitCharacters: v => v && v.length <= 255 || 'Limite de 255 caracteres.'
    },
  }),

  created() {
    this.inicializar();
  },

  watch: {
    isFormValid() {
      this.modalCustomSize.isButtonsDisabled = !this.isFormValid;
    },
  },

  methods: {
    async inicializar() {
      try {
        let response = await axios.get("itemSistema", this.config);
        this.itens = response.data

        this.erro = false;
      } catch (error) {
        this.erro = true;
        this.mensagemErro = error;
      } finally {
        this.showSkeletonTable = false;
      }
    },

    async onFormModalAction() {
      try {
        this.modalCustomSize.isButtonsDisabled = true;

        if (this.modalCustomSize.isEdit) {
          await this.atualizarItem(this.modalCustomSize.actualEdit);
        } else {
          await this.inserirItem(this.modalCustomSize.actualEdit);
        }
      } catch (error) {
        console.log(error);
      }
    },

    async inserirItem(item) {
      this.mensagemErroModal.erro = false;
      try {
        await axios.post("itemSistema", item, this.config);

        this.modalCustomSize.isOpen = false;
        this.showSkeletonTable = true;
      } catch (error) {
        this.mensagemErroModal.erro = true;
        this.mensagemErroModal.text = error;
        this.modalCustomSize.isButtonsDisabled = false;
        this.itemSelecionado = null;
      } finally {
        this.inicializar()
      }
    },

    async atualizarItem(item) {
      this.mensagemErroModal.erro = false;
      try {
        await axios.put("itemSistema", item, this.config);

        this.modalCustomSize.isOpen = false;
        this.showSkeletonTable = true;
      } catch (error) {
        this.mensagemErroModal.erro = true;
        this.mensagemErroModal.text = error;
        this.modalCustomSize.isButtonsDisabled = false;
      } finally {
        this.inicializar()
      }
    },

    async deletarItem(item) {
      this.erro = false;
      try {
        if(confirm("Você realmente deseja deletar o Produto do sistema?")) {
            await axios.put("itemSistemaDesativar", item, this.config);
    
            this.modalCustomSize.isOpen = false;
            this.showSkeletonTable = true;
        }
      } catch (error) {
        console.log(error);
        this.erro = true;
        this.mensagemErro = error;

      } finally {
        this.inicializar()
      }
    },

    //MODAL POPULATE FUNCTIONS
    abrirModalInserir() {
      this.loading = true
      this.mensagemErroModal.erro = false;

      this.modalCustomSize.isOpen = true;
      this.modalCustomSize.isEdit = false;
      this.modalCustomSize.isButtonsDisabled = !this.isFormValid;
      this.modalCustomSize.formTitle = "Novo Produto";
      this.modalCustomSize.buttonText = "Concluir";

      this.modalCustomSize.actualEdit.numeroItemSistema = null
      this.modalCustomSize.actualEdit.nomeItem = null
      this.modalCustomSize.actualEdit.descricaoItem = null
      this.modalCustomSize.actualEdit.tipoProduto = null
      this.loading = false
    },

    abrirModalEditar(item) {
      this.loading = true
      this.mensagemErroModal.erro = false;

      this.modalCustomSize.isOpen = true;
      this.modalCustomSize.isEdit = true;
      this.modalCustomSize.isButtonsDisabled = !this.isFormValid;
      this.modalCustomSize.formTitle = "Produto selecionado";
      this.modalCustomSize.buttonText = "Concluir";

      this.modalCustomSize.actualEdit.numeroItemSistema = item.numeroItemSistema
      this.modalCustomSize.actualEdit.nomeItem = item.nomeItemSistema
      this.modalCustomSize.actualEdit.descricaoItem = item.descricaoItemSistema
      this.modalCustomSize.actualEdit.tipoProduto = item.indicadorTipo
      this.loading = false
    },
  },
};
</script>
